// Pure list helpers for the Tray Management infinite scroll. Every helper
// returns a new array — the list in state is never edited in place.

/** Adds a fetched page, skipping trays already shown (offsets can shift between loads). */
export const appendPage = (current, incoming) => {
  const shown = new Set(current.map((tray) => tray.tray_id));
  return [...current, ...incoming.filter((tray) => !shown.has(tray.tray_id))];
};

/** Swaps in the tray the server returned after a save. */
export const replaceTray = (list, saved) =>
  list.map((tray) => (tray.tray_id === saved.tray_id ? { ...tray, ...saved } : tray));

/** Drops a tray that no longer belongs in the current Active / Inactive tab. */
export const removeTray = (list, trayId) => list.filter((tray) => tray.tray_id !== trayId);

/**
 * The page to fetch next, worked out from how many trays are loaded rather than
 * a running counter: when a tray leaves the tab (inactivated / reactivated) the
 * server's offsets move up by one, and re-asking for the last page picks up the
 * tray that moved into it instead of skipping it. If that page added nothing new
 * (someone else added trays meanwhile), move on so it can't loop.
 */
export const nextPageToLoad = ({ loadedCount, pageSize, lastPage, lastAdded }) => {
  const page = Math.floor(loadedCount / pageSize) + 1;
  return page <= lastPage && lastAdded === 0 ? lastPage + 1 : page;
};

// The backend can answer HTTP 200 with { status: false, message } — treat that as a failure.
export const failureMessage = (res) =>
  res?.data?.status === false ? res?.data?.message || "Request failed" : null;

// Rejected requests (404 / 409 / 403) carry the reason in the body's message.
export const errorMessage = (err, fallback) => err?.response?.data?.message ?? fallback;
